import { FC, ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { LanguageHelper, UiHelper, UrlHelper } from '../../utils/helpers'
import MetadataService from '../../services/MetadataService'
import { checkVersionAndRefresh } from '../../utils/helpers/VersionHelper'
import TenantService from '../../services/TenantService'
import { LANGUAGE_SELECTION_DATA } from '../../utils/constants/Countries'

interface IPublic {
  children?: ReactNode
}

const Common: FC<IPublic> = ({ children }) => {
  const { search } = useLocation()
  const { data: user } = TenantService.getCurrentUser(false, false)
  const { data } = MetadataService.getStaticMetaFile()

  const setLanguageFromQuery = () => {
    const lang = UrlHelper.getQueryParam(search, 'lang')
    const langIsValid = LANGUAGE_SELECTION_DATA.find(item => item.value === lang)
    lang && langIsValid && LanguageHelper.change(lang)
  }

  useEffect(() => {
    if (!data?.version) {
      return
    }

    checkVersionAndRefresh(data?.version)
  }, [data?.version])

  useEffect(() => {
    LanguageHelper.change(user?.data?.language || LanguageHelper.get())
  }, [user])

  useEffect(() => {
    UiHelper.saveVisitingInfo()
    setLanguageFromQuery()
  }, [])

  return <>{children}</>
}

export default Common
